<template>
  <vs-table hover-flat v-if="faxes && faxes.length" :data="faxes">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('fax_received_at')"></vs-th>
      <vs-th v-text="$t('fax_caller_id')"></vs-th>
      <vs-th v-text="$t('fax_did')"></vs-th>
      <vs-th v-text="$t('fax_pages')"></vs-th>
      <vs-th v-text="$t('status')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count"></vs-td>
        <vs-td v-text="tr.received_at"></vs-td>
        <vs-td v-text="tr.caller_id"></vs-td>
        <vs-td v-text="tr.did"></vs-td>
        <vs-td v-text="tr.pages"></vs-td>
        <vs-td>
          <vs-chip :color="statusColor(tr.status)" v-text="$t(`fax_inbound_status_${tr.status}`)"></vs-chip>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button
              v-if="tr.has_file"
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-file-text"
              size="small"
              class="mr-2"
              @click.prevent="$emit('openFile', tr.uuid)"
            >{{ $t('fax_open_pdf') }}</vs-button>
            <vs-button
              v-if="tr.status === 'received'"
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-check"
              size="small"
              @click.prevent="$emit('markRead', tr.uuid)"
            >{{ $t('fax_mark_read') }}</vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Fax.InboundList',
  props: {
    faxes: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    statusColor (status) {
      switch (status) {
      case 'error':
        return 'danger'
      case 'received':
        return 'warning'
      default:
        // read / archived
        return 'success'
      }
    }
  }
}
</script>

<style scoped>

</style>
